import { AmountOffCouponBase } from '../amount-off/amount-off-base';
import { FirstMatchGroupItemTriggerItemsQualifier } from "../../coupon-qualifiers/trigger-items/first-match-group-item-trigger-items";
export class DollarAmountOffCoupon extends AmountOffCouponBase {
    constructor(appType, sourceData, deps, baseData, identity) {
        super(appType, sourceData, deps, baseData, identity);
        this._preQualifiers.push(new FirstMatchGroupItemTriggerItemsQualifier(this._data));
    }
    getDiscountItems(cart) {
        return this._getDiscountItemsFromTriggers(cart);
    }
    computeDiscountAmount(totalAmounts, cart) {
        let amt = this._discountAmount - totalAmounts.couponAddOnPrice;
        amt = Math.max(0, this._adjustDiscountAmount(cart, amt));
        return amt;
    }
}
//# sourceMappingURL=dollar-amount-off.js.map